/* Site 2.x P0.5 Erin/shared PDP option guards. Hide undefined Hand-touched + impossible radios. */
(function () {
  function productRoot() {
    return document.querySelector('.product-section[data-product-handle]') || document.querySelector('.product-section');
  }

  function isGuardedContext(pr) {
    if (!pr) return false;
    if (document.querySelector('[data-mfac-erin-pdp="1"]')) return true;
    var tags = (pr.getAttribute('data-product-tags') || '').toLowerCase();
    if (tags.indexOf('erin sabado') !== -1) return true;
    if (tags.indexOf('paulo sabado') !== -1) return true;
    var artist = document.querySelector('.mfac-pdp-artist');
    if (artist && /erin sabado|paulo sabado/i.test(artist.textContent || '')) return true;
    // Also run when Hand-touched or Original material inputs exist (Tempest / Wailea Ti)
    var mat = pr.querySelector('.variant-input-wrap[data-handle="material"]');
    if (mat) {
      var vals = mat.querySelectorAll('.variant-input[data-value]');
      for (var i = 0; i < vals.length; i++) {
        var v = vals[i].getAttribute('data-value') || '';
        if (/hand-touched|original/i.test(v)) return true;
      }
    }
    return false;
  }

  function selectedValue(pr, handle) {
    var wrap = pr.querySelector('.variant-input-wrap[data-handle="' + handle + '"]');
    if (!wrap) return '';
    var checked = wrap.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : '';
  }

  function hideInput(el, hide) {
    if (!el) return;
    el.classList.toggle('mfac-p0-hidden', !!hide);
    el.style.display = hide ? 'none' : '';
    var input = el.querySelector('input[type="radio"]');
    if (input && hide && input.checked) {
      input.checked = false;
    }
  }

  function preferFirstVisible(wrap) {
    if (!wrap) return;
    var prefer = Array.prototype.find.call(wrap.querySelectorAll('.variant-input'), function (el) {
      return !el.classList.contains('mfac-p0-hidden') && el.style.display !== 'none';
    });
    if (!prefer) return;
    var inp = prefer.querySelector('input');
    if (inp && !inp.checked) {
      inp.checked = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyGuards(pr) {
    if (!pr || !isGuardedContext(pr)) return;
    var materialWrap = pr.querySelector('.variant-input-wrap[data-handle="material"]');
    var material = selectedValue(pr, 'material');
    var size = selectedValue(pr, 'image-size');
    var frameWrap = pr.querySelector('.variant-input-wrap[data-handle="frame-style"]');
    var sizeWrap = pr.querySelector('.variant-input-wrap[data-handle="image-size"]');

    // P0.5: hide undefined Hand-touched (+ keep Original hidden if theme still emits it)
    if (materialWrap) {
      materialWrap.querySelectorAll('.variant-input').forEach(function (el) {
        var v = el.getAttribute('data-value') || '';
        hideInput(el, /hand-touched|hand touched|^original$/i.test(v));
      });
      var mChecked = materialWrap.querySelector('input[type="radio"]:checked');
      if (!mChecked || (mChecked.closest('.variant-input') && mChecked.closest('.variant-input').classList.contains('mfac-p0-hidden'))) {
        preferFirstVisible(materialWrap);
        material = selectedValue(pr, 'material');
      }
    }

    if (frameWrap) {
      frameWrap.querySelectorAll('.variant-input').forEach(function (el) {
        var v = el.getAttribute('data-value') || '';
        var hide = false;
        if (/hand-touched/i.test(material)) {
          hide = !/^no frame$/i.test(v);
        } else if (/^canvas$/i.test(material)) {
          hide = /border/i.test(v) || /luxury/i.test(v) || /^deep/i.test(v);
        } else if (/^metal$/i.test(material) && /16/.test(size) && /24/.test(size)) {
          hide = /luxury/i.test(v);
        }
        hideInput(el, hide);
      });
      var checked = frameWrap.querySelector('input[type="radio"]:checked');
      if (!checked || (checked.closest('.variant-input') && checked.closest('.variant-input').classList.contains('mfac-p0-hidden'))) {
        preferFirstVisible(frameWrap);
      }
    }

    if (sizeWrap && /hand-touched/i.test(material)) {
      sizeWrap.querySelectorAll('.variant-input').forEach(function (el) {
        var v = el.getAttribute('data-value') || '';
        hideInput(el, /40/.test(v) && /60/.test(v));
      });
      var sc = sizeWrap.querySelector('input[type="radio"]:checked');
      if (!sc || (sc.closest('.variant-input') && sc.closest('.variant-input').classList.contains('mfac-p0-hidden'))) {
        preferFirstVisible(sizeWrap);
      }
    } else if (sizeWrap) {
      sizeWrap.querySelectorAll('.variant-input').forEach(function (el) {
        hideInput(el, false);
      });
    }
  }

  function boot() {
    var pr = productRoot();
    if (!pr) return;
    applyGuards(pr);
    pr.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[data-variant-input], input[type="radio"]')) {
        applyGuards(pr);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
